import useAppQuery from 'core/query-client/useAppQuery';
import { getRecentProjects } from 'shared/api/projects/http';

const useRecentProjectsQuery = () => useAppQuery('recent-projects', getRecentProjects);

export default useRecentProjectsQuery;
